module.exports = __webpack_public_path__ + "media/images/title_desktop-28bb4026bc42e19c425fbc6a320cbad5.png";